import { Button, Grid2 as Grid, Grid2Props, IconButton } from "@mui/material";
import React from "react";
import { singleGridItem } from "../../components/forms/fields/defaultStyles";
import FormLabel from "../../components/forms/common/base/FormLabel";
import ArraySubFormProvider from "../../components/forms/fields/subForms/array/ArraySubFormProvider";
import ArraySubFormList from "../../components/forms/fields/subForms/array/ArraySubFormList";
import FormEntitySelectionField from "../../components/forms/fields/basic/EntitySelectionField";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import renderVersionSelection from "../../components/entitiesReferences/SelectionModals/VersionSelectionModal";
import ArraySubFormAdd from "../../components/forms/fields/subForms/array/ArraySubFormAdd";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { useFormHandlerContext } from "../../controllers/formController";
import { Version } from "../../types/version";

interface VersionsListProps extends Grid2Props {
  name: string;
  label: string;
  rowLabel: string;
  language: Version["system_language_type"];
  disabled?: boolean;
}

const VersionsList: React.FC<VersionsListProps> = ({
  name,
  label,
  rowLabel,
  language,
  disabled = false,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();

  return (
    <Grid container spacing={1} {...singleGridItem} {...grid}>
      <FormLabel label={label} name={name} />
      <ArraySubFormProvider name={name}>
        <ArraySubFormList
          renderItem={(index, remove) => (
            <FormEntitySelectionField
              name="version"
              label={`${rowLabel} ${index + 1}`}
              labelActions={
                <IconButton
                  color="error"
                  onClick={() => remove()}
                  size="small"
                  disabled={disabled || isProcessing}
                >
                  <RemoveCircleOutline />
                </IconButton>
              }
              entityCollection={SystemEntityCollections.VERSION}
              disabled={disabled || isProcessing}
              required
              placeholder={"Select a version"}
              renderEntitySelection={renderVersionSelection(language)}
            />
          )}
        />
        <Grid {...singleGridItem}>
          <ArraySubFormAdd
            render={(append) => (
              <Button
                variant="contained"
                fullWidth
                color="primary"
                startIcon={<AddCircleOutline />}
                onClick={() => append({ value: null })}
                disabled={disabled || isProcessing}
              >
                Add {rowLabel}
              </Button>
            )}
          />
        </Grid>
      </ArraySubFormProvider>
    </Grid>
  );
};

export default VersionsList;
